import React from 'react';

const PrivilegeTable = ({ data, onCheckboxChange }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200">
        <thead>
          <tr className="bg-red-700 text-white">
            <th className="py-2 px-4 border-b text-left">Module</th>
            <th className="py-2 px-4 border-b text-left">Page Name</th>
            <th className="py-2 px-4 border-b text-center">Page Allow</th>
            <th className="py-2 px-4 border-b text-center">Print</th>
            <th className="py-2 px-4 border-b text-center">Add</th>
            <th className="py-2 px-4 border-b text-center">Edit</th>
            <th className="py-2 px-4 border-b text-center">Delete</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id} className="hover:bg-gray-50">
              <td className="py-2 px-4 border-b">{row.module}</td>
              <td className="py-2 px-4 border-b">{row.page_name}</td>
              <td className="py-2 px-4 border-b text-center">
                <input
                  type="checkbox"
                  checked={row.pageallow}
                  onChange={() => onCheckboxChange(row.id, 'pageallow')}
                  className="w-5 h-5"
                />
              </td>
              <td className="py-2 px-4 border-b text-center">
                <input
                  type="checkbox"
                  checked={row.print_allow}
                  onChange={() => onCheckboxChange(row.id, 'print_allow')}
                  className="w-5 h-5"
                />
              </td>
              <td className="py-2 px-4 border-b text-center">
                <input
                  type="checkbox"
                  checked={row.add_allow}
                  onChange={() => onCheckboxChange(row.id, 'add_allow')}
                  className="w-5 h-5"
                />
              </td>
              <td className="py-2 px-4 border-b text-center">
                <input
                  type="checkbox"
                  checked={row.edit_allow}
                  onChange={() => onCheckboxChange(row.id, 'edit_allow')}
                  className="w-5 h-5"
                />
              </td>
              <td className="py-2 px-4 border-b text-center">
                <input
                  type="checkbox"
                  checked={row.delete_allow}
                  onChange={() => onCheckboxChange(row.id, 'delete_allow')}
                  className="w-5 h-5"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PrivilegeTable;